import React, { useState } from 'react'

interface ExportMoodboardModalProps {
  show: boolean
  onClose: () => void
  project: any
  onExport: (options: any) => void
}

const defaultOptions = {
  prices: true,
  nameVisible: true,
  creationDate: true,
  productLinks: true,
  extraDescription: false
}

const ExportMoodboardModal: React.FC<ExportMoodboardModalProps> = ({ show, onClose, project, onExport }) => {
  const [options, setOptions] = useState({ ...defaultOptions })
  const [language, setLanguage] = useState('pl')
  const [orientation, setOrientation] = useState<'vertical' | 'horizontal'>('horizontal')
  const [imageSize, setImageSize] = useState<'L' | 'M' | 'S'>('M')
  const [isLoading, setIsLoading] = useState(false)

  if (!show) return null

  const handleExport = async () => {
    setIsLoading(true)
    try {
      await onExport({ ...options, language, orientation, imageSize })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='modal show' style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className='modal-dialog' style={{ maxHeight: '90vh', margin: '30px auto' }}>
        <div className='modal-content' style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
          <div className='modal-header'>
            <h5 className='modal-title'>Opcje eksportowania moodboardu</h5>
            <button type='button' className='close' onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <div className='modal-body' style={{ overflowY: 'auto', flex: '1 1 auto' }}>
            <div className='row'>
              <div className='col-md-6'>
                <div className='mb-3'>
                  <div className='form-check'>
                    <input className='form-check-input' type='checkbox' id='prices' checked={options.prices} onChange={e => setOptions({ ...options, prices: e.target.checked })} />
                    <label className='form-check-label' htmlFor='prices'>Ceny</label>
                  </div>
                  <div className='form-check'>
                    <input className='form-check-input' type='checkbox' id='nameVisible' checked={options.nameVisible} onChange={e => setOptions({ ...options, nameVisible: e.target.checked })} />
                    <label className='form-check-label' htmlFor='nameVisible'>Nazwa</label>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='mb-3'>
                  <div className='form-check'>
                    <input className='form-check-input' type='checkbox' id='productLinks' checked={options.productLinks} onChange={e => setOptions({ ...options, productLinks: e.target.checked })} />
                    <label className='form-check-label' htmlFor='productLinks'>Linki do produktów</label>
                  </div>
                </div>
              </div>
            </div>
            <div className='mt-3'>
              <label className='form-label'>Orientacja</label>
              <div>
                <label className='mr-3'><input type='radio' name='orientation' checked={orientation === 'vertical'} onChange={() => setOrientation('vertical')} /> Orientacja pionowa</label>
                <label><input type='radio' name='orientation' checked={orientation === 'horizontal'} onChange={() => setOrientation('horizontal')} /> Orientacja pozioma</label>
              </div>
            </div>
            <div className='mt-3'>
              <label className='form-label'>Rozmiar zdjęć</label>
              <div>
                <label className='mr-3'><input type='radio' name='imgsize' checked={imageSize === 'L'} onChange={() => setImageSize('L')} /> L</label>
                <label className='mr-3'><input type='radio' name='imgsize' checked={imageSize === 'M'} onChange={() => setImageSize('M')} /> M</label>
                <label><input type='radio' name='imgsize' checked={imageSize === 'S'} onChange={() => setImageSize('S')} /> S</label>
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <button
              className={`
                tw-text-center tw-font-semibold tw-rounded-md tw-shadow-lg tw-transition-colors
                tw-text-teal
                tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-white hover:tw-bg-opacity-90 focus:tw-bg-white
                tw-min-w-[120px] tw-flex tw-items-center tw-justify-center
              `}
              onClick={onClose}
              disabled={isLoading}
            >
              Anuluj
            </button>
            <button
              className={`
                tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                tw-text-white tw-min-w-[120px]
                tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                tw-flex tw-items-center tw-justify-center tw-gap-2
                ${isLoading ? 'tw-opacity-75' : ''}
              `}
              onClick={handleExport}
              disabled={isLoading}
            >
              {isLoading
                ? (
                  <>
                    <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true' style={{ width: '1rem', height: '1rem' }} />
                    <span>Generowanie...</span>
                  </>
                  )
                : (
                    'Pobierz PDF'
                  )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExportMoodboardModal
